// extracted by mini-css-extract-plugin
var _1 = "StaffTables__add--An3G3 SchoolGeneral__add--HUNaY SchoolGeneral__button--ZIm36";
var _2 = "StaffTables__classWidth--Ls1Dp";
var _3 = "StaffTables__editable--pzj0n AccountList__editable--mNgW9";
var _4 = "StaffTables__email--qNZlP";
var _5 = "StaffTables__emailWidth--SYiV4";
var _6 = "StaffTables__empty--zOUxt SchoolGeneral__emptyTable--Sn0gh";
var _7 = "StaffTables__emptyTitle--Jqrho SchoolGeneral__emptyTitle--I1J18";
var _8 = "StaffTables__link--XGaQm SchoolGeneral__link--tS8wu OfficeGeneral__inlineLink--J2Xk5 OfficeGeneral__inlineLinkBase--ofwQY OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _9 = "StaffTables__main--eGvQX";
var _a = "StaffTables__name--Gd0gX SchoolGeneral__tableName--uC45D";
var _b = "StaffTables__nameWidth--Yuy1T";
var _c = "StaffTables__pencil--Zfn7C";
var _d = "StaffTables__remove--QwfzL SchoolGeneral__remove--nz3CD";
var _e = "StaffTables__removeWidth--YTUj1 AccountUser__removeWidth--sIZ8_";
var _f = "StaffTables__schoolWidth--SHvmR";
var _10 = "StaffTables__table--BAG9B SchoolGeneral__genTable--fvnA9";
export { _1 as "add", _2 as "classWidth", _3 as "editable", _4 as "email", _5 as "emailWidth", _6 as "empty", _7 as "emptyTitle", _8 as "link", _9 as "main", _a as "name", _b as "nameWidth", _c as "pencil", _d as "remove", _e as "removeWidth", _f as "schoolWidth", _10 as "table" }
